import './team.css';
import * as React from 'react'
import {Component} from "react";
import {setActiveMenuItem, setLogoWhite, setNavbarTheme} from "../../util";
import {Header, TeamMember} from "../../widgets";


export class Team extends Component {

    componentDidMount() {
        setNavbarTheme('#040f2b');
        setActiveMenuItem('team', window.innerWidth < 1000);
        setLogoWhite(false);
    }

    render() {
        return (
            <div className={'team-container default-large-cage'}>
                <Header text={'Teamet'}/>
                <div className={'team'}>
                    <TeamMember image={'resources/member1.jpg'} name={'Arne Robert Pettersen'} role={'Leder'} email={'arnerp@stud.ntnu.no'}/>
                    <TeamMember image={'resources/member2.jpg'} name={'Amanda Andersson'} role={'Økonomiansvarlig'} email={'amandaa@stud.ntnu.no'}/>
                    <TeamMember image={'resources/member3.jpg'} name={'Benjamin Parr'} role={'Markedsansvarlig'} email={'benjampa@stud.ntnu.no'}/>
                    <TeamMember image={'resources/member4.jpg'} name={'Birk K. Abelvik'} role={'Produktansvarlig'} email={'birkka@stud.ntnu.no'}/>
                    <TeamMember image={'resources/member5.jpg'} name={'Elias Skaare Sætre'} role={'IT-ansvarlig'} email={'eliasss@stud.ntnu.noo'}/>
                </div>
            </div>
        )
    }
}